import { Injectable } from '@angular/core';
import { enableAkitaProdMode } from '@datorama/akita';
import { Observable, of, throwError, catchError, concatMap, first, map, tap  } from 'rxjs';

import { environment } from 'src/environments/environment';
import { AuthService } from '../auth/auth.service';
import { ContentService } from './content.service';
import { LoggerService } from '../logger/logger.service';
import { AnalyticsService } from '../analytics/analytics.service';

@Injectable({
	providedIn: 'root'
})
export class BootstrapService {
	private readonly loggerName = 'BootstrapService';

	constructor(
		private analyticsService: AnalyticsService,
		private loggerService: LoggerService,
		private authService: AuthService,
		private content: ContentService
	) {}

	preLoad(): Observable<void> {
		if (environment.production) {
			enableAkitaProdMode();
		}

		return this.loggerService.init().pipe(
			concatMap(() => this.checkCookiesEnabled()),
			concatMap(() => this.analyticsService.init()),
			concatMap(() => this.content.init()),
			concatMap(() => this.authService.initialize()),
			tap(() => this.loggerService.info(this.loggerName, 'Bootstrap finished')),
			map(() => void 0),
			catchError(err => {
				console.error(`${this.loggerName} Error initializing app`, err);
				return throwError(err);
			})
		);
	}

	// Cookies are required for the authService
	private checkCookiesEnabled(): Observable<void> {
		if (this.areCookiesEnabled()) {
			return of(void 0).pipe(first());
		}
		else {
			this.loggerService.error(this.loggerName, 'Cookies disabled');
			window.location.href = environment.routing.cookiesDisabled;
			return throwError('cookies-disabled');
		}
	}

	private areCookiesEnabled(): boolean {
		const testCookieName = 'testcookie';

		var cookieEnabled = (navigator.cookieEnabled) ? true : false;
	
		if (typeof navigator.cookieEnabled === undefined && !cookieEnabled) { 
			document.cookie = testCookieName;
			cookieEnabled = (document.cookie.indexOf(testCookieName) != -1) ? true : false;
		}

		return cookieEnabled;
	}
}